module.exports = __webpack_public_path__ + "static/media/desktop.27dabed4.svg";